














































import { Vue, Component, Prop } from 'vue-property-decorator';
import type { ContentLinkBlock } from '@getaccept/lib-shared/src/types/content-link';
import type { EntityTheme } from '@getaccept/lib-shared/src/types/theme';
import ThemedButton from '@getaccept/lib-shared/src/components/ThemedButton.vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';
import BrokenImage from './BrokenImage.vue';
@Component({
  components: {
    ThemedButton,
    BrokenImage,
  },
})
export default class ContentLinkPage extends Vue {
  @Prop() contentLinkBlock!: ContentLinkBlock;
  @Prop() theme: EntityTheme;
  @Prop({ default: false }) documentEdit: boolean;

  imageBroken = false;
  imageLoaded = false;
  tooltipOpen = false;

  get hasImage(): boolean {
    return !!this.imageUrl;
  }

  get hasTheme(): boolean {
    return !!this.theme;
  }

  get buttonText(): string {
    if (this.contentLinkBlock?.buttonText) {
      return this.contentLinkBlock.buttonText;
    }
    return t('open-link').toString();
  }

  get title(): string {
    return this.contentLinkBlock?.title || '';
  }

  get url(): string {
    return this.contentLinkBlock?.url || '';
  }

  get description(): string {
    return this.contentLinkBlock?.description || '';
  }

  get imageUrl(): string {
    return this.contentLinkBlock?.thumbUrl || '';
  }

  handleClick() {
    if (this.documentEdit) {
      this.showTooltip();
    } else {
      this.openUrl(this.url);
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeTooltip();
    }
  }

  showTooltip() {
    this.tooltipOpen = true;
  }

  closeTooltip() {
    this.tooltipOpen = false;
  }

  openUrl(contentLinkUrl: string) {
    const url = UrlHelper.getHttpsUrl(contentLinkUrl);
    window.open(url, '_blank');
    this.$emit('click', this.contentLinkBlock.id);
    this.closeTooltip();
  }

  handleLoadImageError() {
    this.imageBroken = true;
  }

  handleLoaded() {
    this.imageLoaded = true;
  }

  mounted() {
    if (this.documentEdit) {
      document.addEventListener('keydown', this.handleKeydown);
    }
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
